import axios from 'axios'
import '../Config'

const jwtToken = localStorage.getItem("authorization");

const INSTRUCTOR = 'v1'
const COURSE_API_URL = global.config.backend
const INSTRUCTOR_API_URL = `${COURSE_API_URL}/${INSTRUCTOR}`

class UsuarioService {

    getByUsuario(usuario) {
        return axios.get(`${INSTRUCTOR_API_URL}/usuario/getbyusuario?usuario=${usuario}`);
    }

    async alterKey(id, password, newPassword) {
        return await axios.post(`${INSTRUCTOR_API_URL}/usuario/alterKey`, {id: id, password: password, newPassword: newPassword});
    }

}

export default new UsuarioService()